import { useAuthStore } from '@/store/auth'
import { Navigate, useLocation } from 'react-router-dom'

export default function PublicRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore(state => state.user)
  const isAuthenticated = !!user
  const location = useLocation()

  if (isAuthenticated) {
    const from = location.state?.from?.pathname || '/dashboard'
    return <Navigate to={from} state={{ from: location }} replace />
  }

  return children
}